import React from 'react';
import cc from 'classcat';

interface CheckboxProps {
    id: string;
    label?: string;
    checked?: boolean;
    handleChange?: React.ChangeEventHandler<HTMLInputElement>;
    className?: string;
    isDisabled?: boolean;
    labelClassName?: string;
}

export const Checkbox = ({ id, label, checked, handleChange, className, isDisabled, labelClassName }: CheckboxProps) => {
    return (
        <div className={cc(['checkbox-n', className])}>
            <input id={id} type="checkbox" checked={checked} disabled={isDisabled} onChange={handleChange} />
            {label && (
                <label htmlFor={id} className={cc([labelClassName || 'paragraph-4'])}>
                    {label}
                </label>
            )}
        </div>
    );
};
